import { NIL as empty } from 'uuid';
import IPassword from '../../models/password/IPassword';

const newPassword = (folderId: string, isPersonal: boolean = false): IPassword => ({
    id: empty,
    username: '',
    password: '',
    label: '',
    notes: '',
    folderId,
    mfa: {
        notes: '',
        tokens: [],
    },
    isPersonal,
    audience: [],
    attributes: []
});

export default newPassword;